export enum ENVIRONMENT {
  STAGING = 'staging',
  PRODUCTION = 'production',
}

/**
 * This is a function, and not just a constant, so we can get around
 * module caching in tests.
 */
export const getEnv = (): ENVIRONMENT => {
  if (process.env.REACT_APP_ENV === 'production') {
    return ENVIRONMENT.PRODUCTION;
  }

  return ENVIRONMENT.STAGING;
};

/**
 * Is this production? Is this real life?
 */
export const isProduction = () => getEnv() === ENVIRONMENT.PRODUCTION;

export const isStaging = () => getEnv() === ENVIRONMENT.STAGING;

/* NODE_ENV is set by CRA. It will be "production" for builds and "development" when running the code locally */
export const isDeploymentBuild = () => process.env.NODE_ENV === 'production';
